// extracted by mini-css-extract-plugin
export default {"overviewTableCell":"styles_overviewTableCell__jd6ne","stripes":"styles_stripes__mG+MU"};